import { useState } from 'react'
import { supabase } from './supabaseClient'

export default function SetPassword({ onBack }) {
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleSave = async () => {
    setError('')
    if (password.length < 6) {
      setError('Password must be at least 6 characters.')
      return
    }
    if (password !== confirm) {
      setError('Passwords do not match.')
      return
    }
    setLoading(true)
    const { error } = await supabase.auth.updateUser({ password })
    if (error) {
      setError(error.message)
    } else {
      setSuccess(true)
    }
    setLoading(false)
  }

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="bg-gray-800 rounded-lg p-8 w-full max-w-md">
        <h1 className="text-white text-2xl font-bold text-center mb-2">
          {success ? 'Password Set' : 'Set Your Password'}
        </h1>
        <p className="text-gray-400 text-center mb-8 text-sm">
          {success
            ? 'You can use this password to sign in from now on.'
            : 'Choose a password so you can sign in directly next time, instead of requesting a new link each visit.'}
        </p>

        {!success && (
          <>
            {error && (
              <div className="bg-red-900 text-red-200 p-3 rounded mb-4 text-sm">
                {error}
              </div>
            )}
            <input
              type="password"
              placeholder="New password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full bg-gray-700 text-white p-3 rounded mb-3 outline-none focus:ring-2 focus:ring-green-500"
            />
            <input
              type="password"
              placeholder="Confirm password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSave()}
              className="w-full bg-gray-700 text-white p-3 rounded mb-6 outline-none focus:ring-2 focus:ring-green-500"
            />
            <button
              onClick={handleSave}
              disabled={loading || !password || !confirm}
              className="w-full bg-green-700 hover:bg-green-600 disabled:bg-gray-600 text-white font-bold py-3 rounded transition-colors mb-3"
            >
              {loading ? 'Saving...' : 'Save Password'}
            </button>
          </>
        )}

        <button
          onClick={onBack}
          className="w-full bg-gray-700 hover:bg-gray-600 text-white font-bold py-3 rounded transition-colors"
        >
          {success ? 'Done' : 'Cancel'}
        </button>
      </div>
    </div>
  )
}
